import { render, staticRenderFns } from "./StepTermsAndConditions.vue?vue&type=template&id=21cd6f50&scoped=true&"
import script from "./StepTermsAndConditions.vue?vue&type=script&lang=js&"
export * from "./StepTermsAndConditions.vue?vue&type=script&lang=js&"
import style0 from "./StepTermsAndConditions.vue?vue&type=style&index=0&id=21cd6f50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cd6f50",
  null
  
)

export default component.exports